export default class ViewRichTextEditorVO
{

	// ----------------------------------
	//	Properties
	// ----------------------------------

	defaultValue = '';
	name = "Rich text editor";
	fieldType = 'richTextEditor';
	uiComponent = 'view-rich-text-editor-field';
	description = 'Editor with formatting options.';

	constructor()
	{
		
	}
}